function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  id: "Group_4694",
  "data-name": "Group 4694",
  xmlns: "http://www.w3.org/2000/svg",
  width: "22.326",
  height: "20"
}, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path"
}, /*#__PURE__*/React.createElement("path", {
  id: "Rectangle_1955",
  "data-name": "Rectangle 1955",
  fill: "#fff",
  d: "M0 0h22.326v20H0z"
}))), /*#__PURE__*/React.createElement("path", {
  id: "Rectangle_1950",
  "data-name": "Rectangle 1950",
  transform: "translate(3.467 10)",
  fill: "#fff",
  d: "M0 0h7.038v1.314H0z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Rectangle_1951",
  "data-name": "Rectangle 1951",
  transform: "translate(3.494 7.371)",
  fill: "#fff",
  d: "M0 0h7.832v1.314H0z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Rectangle_1952",
  "data-name": "Rectangle 1952",
  transform: "translate(3.494 4.743)",
  fill: "#fff",
  d: "M0 0h4.011v1.314H0z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Rectangle_1953",
  "data-name": "Rectangle 1953",
  transform: "translate(3.467 12.629)",
  fill: "#fff",
  d: "M0 0h7.038v1.314H0z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Rectangle_1954",
  "data-name": "Rectangle 1954",
  transform: "translate(3.467 15.257)",
  fill: "#fff",
  d: "M0 0h8.65v1.314H0z"
}), /*#__PURE__*/React.createElement("g", {
  id: "Group_4697",
  "data-name": "Group 4697"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_4696",
  "data-name": "Group 4696",
  clipPath: "url(#clip-path)",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_2513",
  "data-name": "Path 2513",
  d: "M16 16.156V18H2V2h10v4h4v3.469l2-2V5l-5-5H1a1 1 0 00-1 .992v18.016A1 1 0 00.993 20h16.014A1 1 0 0018 18.993v-4.837z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_2514",
  "data-name": "Path 2514",
  d: "M14.793 15.948l-3.467-3.218 1.855-2 1.541 1.43L20.4 6.487l1.929 1.928z"
})))));